import semver from 'semver';

/** Versions that ship pruned per-calculator OpenAPI files (e.g. beef.json) plus a calculators.json manifest. */
export function usesSplitOpenApiSpecs(version: string | undefined): boolean {
  return Boolean(version && semver.gt(version, '4.0.1'));
}
